/**
 * Cor da pele
 * - Ignorada, Amarela, Branca, Indígena, Parda, Preta. Conforme CRC.
 */
const PARDO = { name: 'Parda', value: 'PARDA' }
const NEGRO = { name: 'Preta', value: 'PRETA' }
const BRANCO = { name: 'Branca', value: 'BRANCA' }
const INDIGENA = { name: 'Indigena', value: 'INDIGENA' }
const AMARELO = { name: 'Amarela', value: 'AMARELA' }
const IGNORADA = { name: 'Ignorada', value: 'IGNORADA' }

const CORES_PELE = [ PARDO, NEGRO, BRANCO, INDIGENA, AMARELO, IGNORADA ]

export default CORES_PELE
